export const testimonialsData = [
  {
    id: 1,
    name: 'Katherine Brooks',
    role: 'CTO, NovaSpark Inc.',
    avatar: 'KB',
    rating: 5,
    text: "ZenTera Tech completely transformed our cloud infrastructure. Our deployment times dropped by 70% and costs are down 40%. Their team doesn't just deliver — they over-deliver.",
    company: 'NovaSpark Inc.',
  },
  {
    id: 2,
    name: 'Marcus Thompson',
    role: 'CEO, BrightPath Solutions',
    avatar: 'MT',
    rating: 5,
    text: 'The custom web application they built for us is absolutely stunning and performs flawlessly under heavy traffic. ZenTera Tech is our go-to partner for all things tech.',
    company: 'BrightPath Solutions',
  },
  {
    id: 3,
    name: 'Elena Rodriguez',
    role: 'Product Manager, Retail360',
    avatar: 'ER',
    rating: 5,
    text: 'Our mobile app went from concept to App Store in just 10 weeks. The React Native app they delivered has 4.9 stars and over 50k downloads. Exceptional work!',
    company: 'Retail360',
  },
  {
    id: 4,
    name: 'Benjamin Wright',
    role: 'Marketing Director, GrowthLab',
    avatar: 'BW',
    rating: 5,
    text: "ZenTera's SEO team took us from page 5 to position 1 for our top keywords in just 6 months. Organic traffic tripled and leads are up 180%. The results speak for themselves.",
    company: 'GrowthLab',
  },
  {
    id: 5,
    name: 'Chloe Anderson',
    role: 'Founder, EduFlow',
    avatar: 'CA',
    rating: 5,
    text: "They built our AI-powered recommendation engine from scratch. It's accurate, fast, and our users love it. ZenTera Tech truly understands how to make AI work in the real world.",
    company: 'EduFlow',
  },
  {
    id: 6,
    name: 'Tom Reynolds',
    role: 'Head of E-Commerce, UrbanGoods',
    avatar: 'TR',
    rating: 5,
    text: 'Our WooCommerce store saw a 60% increase in conversion after ZenTera rebuilt it. Performance scores went from 45 to 98 on PageSpeed. Incredible team and communication.',
    company: 'UrbanGoods',
  },
  {
    id: 7,
    name: 'Isabella Garcia',
    role: 'Operations Director, TechFlow',
    avatar: 'IG',
    rating: 5,
    text: 'ZenTera helped us automate 80% of our internal workflows using AI. What used to take our team 3 days now happens in minutes. Highly recommend their AI/ML services.',
    company: 'TechFlow',
  },
  {
    id: 8,
    name: 'Jonathan Reed',
    role: 'Co-Founder, LaunchPad',
    avatar: 'JR',
    rating: 5,
    text: 'From day one, the ZenTera team was professional, communicative, and technically brilliant. Our startup website and app launched on time, on budget, and beyond expectations.',
    company: 'LaunchPad',
  },
];
